module.exports = __webpack_public_path__ + "img/tabaat_yes.e25f6773.png";